import React, { useState } from 'react';
import { Navbar } from '../components/layouts/Navbar';
import { PlannerSidebar } from '../components/layouts/PlannerSidebar';
import { RepassePorDocumentoTable } from '../components/repasse/RepassePorDocumentoTable';

export const RepassesPorDocumento: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F4EFFA' }}>
      <Navbar />
      <div className="flex p-6 gap-3">
        <div className="flex-1">
          {/* Header */}
          <div className="flex justify-between items-center mb-2">
            <div>
              <h1 className="text-xs font-semibold" style={{ color: '#3d2b56' }}>
                Repasses por Documento
              </h1>
              <p className="text-xs mt-1" style={{ color: '#9E9E9E' }}>
                Resumo de repasses agrupados por documento
              </p>
            </div>

            {/* Espaço para ações futuras (exportar, filtros) */}
            <div />
          </div>

          {/* Conteúdo principal */}
          <div className="bg-white rounded-lg shadow-sm p-4">
            <RepassePorDocumentoTable refreshKey={refreshKey} />
          </div>
        </div>

        <div className="hidden lg:block">
          <PlannerSidebar />
        </div>
      </div>
    </div>
  );
};
